import React from "react";

import { cn } from "lib/utils";

import { SkeletonBlock, SkeletonText } from "./SkeletonPrimitives";

type CardGridSkeletonProps = {
  cards?: number;
  className?: string;
  orientation?: "horizontal" | "vertical";
  withCta?: boolean;
};

const CardGridSkeleton = ({
  cards = 3,
  className,
  orientation = "horizontal",
  withCta = false,
}: CardGridSkeletonProps) => {
  const gridClass =
    orientation === "vertical"
      ? "grid-cols-1"
      : "md:grid-cols-2 xl:grid-cols-3";

  return (
    <div
      className={cn(
        "grid gap-4",
        orientation === "horizontal" ? gridClass : "grid-cols-1",
        className,
      )}
      aria-hidden
      data-testid="card-grid-skeleton"
    >
      {Array.from({ length: cards }).map((_, index) => (
        <div
          key={`card-${index}`}
          className="flex flex-col gap-3 rounded-2xl border border-slate-200/70 bg-white/95 p-4"
        >
          <SkeletonText className="h-4 w-32" />
          <SkeletonBlock className="h-10 w-24 rounded-md" />
          <SkeletonText className="h-3 w-2/3" />
          {withCta && (
            <div className="pt-2">
              <SkeletonBlock className="h-9 w-28 rounded-md" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CardGridSkeleton;
